<template>
	<div
		class="code-field"
		:class="[displayPopover ? 'code-field__view-popover' : '']"
	>
		<Button
			:className="'btn--icon-only-circle'"
			labelText=""
			:btnClick="popoverClass"
			iconClassName="icon-info"
			:iconBeforeLabel="true"
		/>

		<Popover
			:text="popoverText"
			:variation="variation"
			v-model="displayPopover"
		/>
	</div>
</template>

<script>
import DocumentClickedMixin from '@/mixins/document-click';
import Popover from '@/components/notifications/popover/popover';
import Button from '@/components/forms/button/button';

export default {
	name: 'ViewCode',
	mixins: [DocumentClickedMixin('closePopoverHandler')],
	components: {
		Popover,
		Button
	},
	props: {
		popoverText: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			displayPopover: false
		};
	},
	computed: {
		isMobile() {
			return this.screenSize.mobile;
		},
		variation() {
			if (this.isMobile) return 'top';
			return 'left';
		}
	},
	methods: {
		popoverClass() {
			this.displayPopover = !this.displayPopover;
		},
		closePopoverHandler() {
			this.displayPopover = false;
		}
	}
};
</script>

<style lang="scss" scoped></style>
